<ppl-box-container [small]="small">
  <div *ngIf="title"
       class="title">{{ title }}</div>
  <div *ngIf="description"
       class="description">
    {{ description }}
  </div>

  <ng-content></ng-content>
</ppl-box-container>
